export const SET_SUBJECT = 'SET_SUBJECT'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_GRADES = 'SET_GRADES'
export const SET_SECTIONS = 'SET_SECTIONS'
export const SET_YEARS = 'SET_YEARS'
export const SET_ORIGINS = 'SET_ORIGINS'
export const SET_SITECHOICES = 'SET_SITECHOICES'
export const SET_ALLRULES = 'SET_ALLRULES'
export const SET_RESET = 'SET_RESET'
export const SET_LOGINMODAL = 'SET_LOGINMODAL'
export const SET_USER = 'SET_USER'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_VERIFY = 'SET_USER_VERIFY'
export const SET_COUPON = 'SET_COUPON'
export const SET_XUEKECHOICE = 'SET_XUEKECHOICE'
export const SET_BINDACCOUNTS = 'SET_BINDACCOUNTS'
export const SET_PAYMODAL = 'SET_PAYMODAL'
export const SET_TIPMODAL = 'SET_TIPMODAL'
export const SET_HANDOUTSHOW = 'SET_HANDOUTSHOW'
